import React from 'react';

export const isSaleBlocked = (item) => (item?.article?.VENTE_BLOQ ?? item?.VENTE_BLOQ) === true;

export const blockedSalesMessage = (items = []) => {
  const codes = [...new Set((items || []).filter(isSaleBlocked).map(item => item.CODE_ART))];
  return codes.length
    ? `Validation impossible : vente bloquée pour les articles ${codes.join(', ')}.`
    : '';
};

export default function SalesBlockedWarning({ item }) {
  if (!isSaleBlocked(item)) return null;
  return (
    <span style={{ color: '#ad4e00', background: '#fff7e6', padding: '2px 6px', borderRadius: 4, whiteSpace: 'nowrap', flexShrink: 0 }}
      title="La vente de cet article est bloquée.">
      <span aria-hidden="true">⚠ </span>Vente bloquée
    </span>
  );
}
